
const PerformanceActionTypes = {
    FETCH_PERFORMANCES_START: "FETCH_PERFORMANCES_START",
    FETCH_PERFORMANCES_SUCCESS: "FETCH_PERFORMANCES_SUCCESS",
    FETCH_PERFORMANCES_FAILURE: "FETCH_PERFORMANCE_FAILURE",
};

export default PerformanceActionTypes;
